import { captureException } from '@sentry/node';

import { doRequest } from '@r1-frontend/do-request';
import { replan } from '@r1-frontend/api-domru/api-request/v1/managing-connection-request/re-plan';
import { IReplanResponse } from '@r1-frontend/api-domru/api-request/v1/managing-connection-request/re-plan/dto/IReplanResponse';

import { setReplanIsError, setSelectedTimeSlot, setStep } from '~/src/features/tariffBuilder/actions';
import { TCtxDispatch } from '~/src/features/tariffBuilder/Ctx';
import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { ESteps } from '~/src/features/tariffBuilder/types/ESteps';

/**
 * Возвращает время в формате для передачи в запрос.
 * '/v1/managing-connection-request/re-plan'
 * @param time - "10:00"
 * @returns "10:00-11:00"
 */
const getTimeRange = (time: string): string => {
    const [hour] = time.split(':');
    if (isNaN(Number(hour))) {
        return hour;
    }
    return `${hour}:00-${Number(hour) + 1}:00`;
};

export interface IParams {
    agreementId?: number,
    selectedDate: string,
    selectedTime: string,
    comment: string,
}

const replanRequest = ({
    agreementId,
    selectedDate,
    selectedTime,
    comment,
}: IParams) => async(dispatch: TCtxDispatch, getState: () => TInitialState) => {
    const state = getState();
    const { client } =  state;

    if (!agreementId) {
        return;
    }

    const planTime = getTimeRange(selectedTime);

    const phoneParam = client.contactPhone?.isContactId
        ? {
            contactId: client.contactPhone.value,
            numberPhone: null,
        }
        : {
            contactId: null,
            numberPhone: client.phone,
        };

    /**
     * TODO - Удалить agreementId когда бэк будет готов.
     * Задача по бэку - https://ticket.ertelecom.ru/browse/WEB-48483
     * Задача на фронт - https://ticket.ertelecom.ru/browse/WEB-48498
     */
    const response = await doRequest.apiRequest<IReplanResponse>(
        replan({
            agreementId,
            planDate: selectedDate,
            planTime,
            text: comment,
            ...phoneParam,
        }),
    );

    if (!response.isSuccess) {
        dispatch(setReplanIsError(true));
        captureException(response.error);
    }

    if (response.isSuccess) {
        dispatch(setSelectedTimeSlot({ date: response.payload.plan_date, hour: response.payload.plan_time, comment }));
    }
    dispatch(setStep(ESteps.Final));
};

export default replanRequest;
